<div class="section-title">
  <fa-icon icon="history"></fa-icon>
  History
</div>
<app-warning-box *ngIf="auditType === 'DEAL' || auditType === 'DEAL_PACKAGE'"
                 id="audit-history-notice"
                 data-testid="audit-history-notice"
                 [boxContent]="auditHistoryWarningBox.content">
</app-warning-box>

<app-filters (buttonClicked)="onButtonClick($event)"
             (filtersChanged)="onFiltersChange($event)"
             [buttons]="auditTableButtons"
             [filters]="auditFilters"
             [isDataLoading]="audit?.isLoading">
</app-filters>

<app-table
  [columnsStorageKey]="auditColumnsStorageKey"
  (tablePageChanged)="onTablePageChange($event)"
  (tableSortChanged)="onTableSortChange($event)"
  [hasFooter]="true"
  [isPaginated]="true"
  [isTableLoading]="audit?.isLoading"
  [tableColumns]="auditTableColumns"
  [tableData]="audit?.data"
  [table]="auditTable"
  [totalRows]="audit?.totalElements">
</app-table>



